export default "__VITE_ASSET__DfwKiu1d__"